import { render } from "./edit-contrat-form.vue?vue&type=template&id=3acb57b2"
import script from "./edit-contrat-form.vue?vue&type=script&lang=js"
export * from "./edit-contrat-form.vue?vue&type=script&lang=js"

import "./edit-contrat-form.vue?vue&type=style&index=0&id=3acb57b2&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__